<template>
  <div @click="$emit('click')" class="directory-root">
     <i class="fas fa-folder-open"/> {{name}}
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, default: '' },
  },
};
</script>

<style scoped>
.directory-root
{
  transition: ease 150ms;
  width: 100%;
  margin: 2px;
  padding: 10px;
  background-color: hsl(210, 16%, 95%);
}

.directory-root:hover
{
  transition: ease 150ms;
  cursor: pointer;
  background-color: hsl(210, 16%, 97%);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/assets/AssetSelectInputDirectoryEntry.vue